module.exports = __webpack_public_path__ + "img/woman.3d1b8411.svg";